import { render, staticRenderFns } from "./InvocationDashboardView.vue?vue&type=template&id=31ef7bfc&scoped=true"
import script from "./InvocationDashboardView.vue?vue&type=script&lang=ts"
export * from "./InvocationDashboardView.vue?vue&type=script&lang=ts"
import style0 from "./InvocationDashboardView.vue?vue&type=style&index=0&id=31ef7bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef7bfc",
  null
  
)

export default component.exports